import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "Customization of the Scoper",
description: "Learn how to replace Freon’s generated scoper with your own implementation and configure the environment to use it.",
tags: [ "scoper", "customization", "Freon", "scope provider", "environment", "DSL development"] ,
modifiedTime: "2025-11-07T17:20:18.626Z",
publishedTime: "2025-11-07T17:20:18.626Z"
    }
  };
};